export default {
  unlockTitle: {
    id: 'product_page_carriers_unlock',
    defaultMessage: 'Works with all carriers',
  },
  unlockSubtitle: {
    id: 'product_page_carriers_phone_unlock',
    defaultMessage: 'This phone is unlocked',
  },
  lockTitle: {
    id: 'product_page_carriers_sim',
    defaultMessage: 'SIM required',
  },
  lockSubtitle: {
    id: 'product_page_carriers_phone_lock',
    defaultMessage: 'This phone is locked',
  },
}
